import { FC } from "react";
import SalesOrderWebLayout from "./WebLayout";

const SalesOrder: FC = () => {
  return (
    <div>
      <SalesOrderWebLayout />
    </div>
  );
};

export default SalesOrder;
